import { render, staticRenderFns } from "./addPurchase.vue?vue&type=template&id=5440aaba&scoped=true&"
import script from "./addPurchase.vue?vue&type=script&lang=js&"
export * from "./addPurchase.vue?vue&type=script&lang=js&"
import style0 from "./addPurchase.vue?vue&type=style&index=0&id=5440aaba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5440aaba",
  null
  
)

export default component.exports